import CommonText from "@/components/common/Text"
import React from "react"
import styled from "styled-components"

const Text = styled(CommonText)`
	width: 100%;
`

export default function TightDescription({ desc, color }) {
	return <Text tag="div" className="typo-strawford typo-strawford-95 description" color={color} dangerouslySetInnerHTML={desc} />
}
